export default __webpack_public_path__ + "static/media/Kannada_bf_2.fc9df004.mp3";